export default {
  inject: ['load'],
  data() {
    return {};
  },
  methods: {
    getPatientInitialAssessmentByIdFunction: function (id) {
      if (!this.load.val) {
        this.load.val = true;
      }
      this.$store.dispatch('getPatientInitialAssessmentById', id).then(() => {
        if (this.$store.state.patientInitialAssessmentModule.successFlag) {
          if (this.load.val) {
            this.load.val = false;
          }
          let temp = this.$store.state.patientInitialAssessmentModule.patientInitialAssessment;
          if (this.$route.name == 'followUpPatiant') {
            if (temp) {
              this.setData(temp);
            }
          }
        } else {
          if (this.load.val) {
            this.load.val = false;
          }
          if (this.$store.state.patientInitialAssessmentModule.errorStatus) {
            this.$store.dispatch('refreshToken').then(() => {
              if (this.$store.state.patientInitialAssessmentModule.successFlag) {
                this.getPatientInitialAssessmentByIdFunction(id);
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else {
            this.showError();
          }
        }
      });
    },
    addPatientInitialAssessmentFunction: function (data) {
      if (!this.load.val) {
        this.load.val = true;
      }
      this.$store.dispatch('addPatientInitialAssessment', data).then(() => {
        if (this.$store.state.patientInitialAssessmentModule.successFlag) {
          if (this.load.val) {
            this.load.val = false;
          }
          if (this.$route.name == 'followUpPatiant') {
            this.patientInitialAssessmentAdded();
          }
        } else {
          if (this.load.val) {
            this.load.val = false;
          }
          if (this.$store.state.patientInitialAssessmentModule.errorStatus) {
            this.$store.dispatch('refreshToken').then(() => {
              if (this.$store.state.patientInitialAssessmentModule.successFlag) {
                this.addPatientInitialAssessmentFunction(data);
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else {
            this.showError();
          }
        }
      });
    },
    showError: function () {
      this.snackText = this.$store.state.patientInitialAssessmentModule.error;
      if (this.$refs.snackRef) {
        this.$refs.snackRef.snackModel = true;
        this.snackColor = '#FF5252';
        this.snakIcon = 'mdi-information';
      } else {
        this.showErrorAlert(this.snackText);
      }
    },
  },
};
